import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { theme } from '../../lib/index';

export const MoreInfoButton = styled(Button, {})({
  position: 'absolute',
  right: 0,
  bottom: 0,
  left: 0,

  padding: '15px 0',
  width: '100%',

  background: `linear-gradient(90deg, ${theme.palette.newPrimary} 0%, ${theme.palette.newSecondary} 100%)`,

  borderRadius: '0 0 15px 15px',

  color: theme.palette.black,
});
